// directives/permission.ts
import { usePermissionStore } from "@/store/permissionStore";
export default {
  beforeMount(el: any, binding: any) {
    const permissionStore = usePermissionStore();
    const { value } = binding;
    // const hasPermission = permissionStore.hasPermission(value);
    // if (el.tagName === "BUTTON") {
    //   el.disabled = true;
    //   el.style.cursor = "not-allowed";
    //   //增加一个class
    //   el.classList.add("is-disabled");
    // }
    if (value && !permissionStore.hasPermission(value) && permissionStore.$state.superAdmin === false) {
      //判断如果是按钮就disable
      if (el.tagName === "BUTTON") {
        el.disabled = true;
        el.style.cursor = "not-allowed";
        //增加一个class
        el.classList.add("is-disabled");
      } else {
        //否则就remove
        el.style.display = "none";
      }
      // el.parentNode && el.parentNode.removeChild(el);
    }
  },
};
